import { Box, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";

export default function UnauthorizedPage() {
    const theme = useTheme();
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "70vh",
                textAlign: "center",
                gap: 2,
                p: 3,
            }}
        >
            <LockOutlinedIcon
                sx={{
                    fontSize: 80,
                    color: theme.palette.text.disabled,
                }}
            />
            <Typography variant="h5" fontWeight={700} color="text.primary">
                Acesso não autorizado
            </Typography>
            <Typography variant="body1" color="text.secondary" maxWidth={450}>
                Você não possui permissão para acessar esta página. Entre em contato com
                o administrador para solicitar acesso.
            </Typography>
            <Button
                variant="contained"
                onClick={() => navigate(-1)}
                sx={{ mt: 2 }}
            >
                Voltar
            </Button>
        </Box>
    );
}
